import { useCallback } from 'react';
import { GmailConnectedRow, GmailConnectRow } from './GmailConnectPanel';
import { claimConnectedFollowUp, connectState, providerList, providerName, providerOf } from './mailUtils';

export default function MailConnectCard({ cardId, data, sendFollowUp }) {
  const provider = providerOf(data?.provider);
  const onConnected = useCallback((app) => {
    if (claimConnectedFollowUp(cardId)) {
      sendFollowUp('connected', `I've connected ${providerName(app || provider)}`, { mail_event: 'connected' });
    }
  }, [cardId, provider, sendFollowUp]);

  const state = connectState(data);
  const email = typeof data?.email === 'string' && data.email.trim() ? data.email.trim() : undefined;
  if (state === 'connected') return <GmailConnectedRow provider={provider} email={email} />;
  return (
    <GmailConnectRow
      state={state}
      provider={provider}
      providers={providerList(data?.providers)}
      email={email}
      connectUrl={typeof data?.connect_url === 'string' ? data.connect_url : undefined}
      connectionId={typeof data?.connection_id === 'string' ? data.connection_id : undefined}
      serverError={typeof data?.error === 'string' ? data.error : null}
      onConnected={onConnected}
      switching={data?.reconnect === true}
      currentProvider={providerOf(data?.current_provider) || null}
    />
  );
}
